/// <amd-module name="VSS/Features/MarkdownEditor/Commands/Toolbar" />
import * as Resources from "VSS/Features/MarkdownEditor/Resources";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { wrapWithCodeSign } from "../Formatting/Code";
import { insertSignAtLineStart, MarkdownSigns, wrapWithSign } from "../Formatting/Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "../Formatting/Contracts";
import { wrapWithLinkSign } from "../Formatting/Link";

export interface IMarkdownToolbarCommand extends IHeaderCommandBarItem {
    formatText?: (
        formattingArgs: IMarkdownFormattingArgs,
        asynErrorHandler?: (error: Error) => void
    ) => IMarkdownFormattingResult | void | Promise<IMarkdownFormattingResult | void>;
    /**
     * Order of the command in the toolbar.
     */
    order?: number;
}

export const Header1: IMarkdownToolbarCommand = {
    id: "header-1",
    formatText: formattingArgs => insertSignAtLineStart(formattingArgs, MarkdownSigns.Header1, [MarkdownSigns.Header2, MarkdownSigns.Header3]),
    text: Resources.Header1Text
};

export const Header2: IMarkdownToolbarCommand = {
    id: "header-2",
    formatText: formattingArgs => insertSignAtLineStart(formattingArgs, MarkdownSigns.Header2, [MarkdownSigns.Header1, MarkdownSigns.Header3]),
    text: Resources.Header2Text
};

export const Header3: IMarkdownToolbarCommand = {
    id: "header-3",
    formatText: formattingArgs => insertSignAtLineStart(formattingArgs, MarkdownSigns.Header3, [MarkdownSigns.Header1, MarkdownSigns.Header2]),
    text: Resources.Header3Text
};

const Header: IMarkdownToolbarCommand = {
    id: "header",
    iconProps: { iconName: "EditStyle" },
    order: 10,
    tooltipProps: { text: Resources.HeaderText },
    subMenuProps: {
        id: "header-menu",
        items: [Header1, Header2, Header3]
    }
};

export const Bold: IMarkdownToolbarCommand = {
    formatText: formattingArgs => wrapWithSign(formattingArgs, MarkdownSigns.Bold),
    iconProps: { iconName: "SemiboldWeight" },
    id: "bold",
    order: 20,
    tooltipProps: { text: Resources.BoldTooltipText }
};
export const Italic: IMarkdownToolbarCommand = {
    formatText: formattingArgs => wrapWithSign(formattingArgs, MarkdownSigns.Italic),
    iconProps: { iconName: "Italic" },
    id: "italic",
    order: 30,
    tooltipProps: { text: Resources.ItalicTooltipText }
};
export const Code: IMarkdownToolbarCommand = {
    formatText: wrapWithCodeSign,
    iconProps: { iconName: "Embed" },
    id: "code",
    order: 40,
    tooltipProps: { text: Resources.CodeTooltipText }
};
export const Link: IMarkdownToolbarCommand = {
    formatText: wrapWithLinkSign,
    iconProps: { iconName: "Link" },
    id: "link",
    order: 50,
    tooltipProps: { text: Resources.LinkTooltipText }
};
export const BulletedList: IMarkdownToolbarCommand = {
    formatText: formattingArgs =>
        insertSignAtLineStart(formattingArgs, MarkdownSigns.BulletedList, [MarkdownSigns.NumberedList, MarkdownSigns.TaskList]),
    iconProps: { iconName: "BulletedList" },
    id: "bulleted-list",
    order: 60,
    tooltipProps: { text: Resources.BulletedListText }
};
export const NumberedList: IMarkdownToolbarCommand = {
    formatText: formattingArgs =>
        insertSignAtLineStart(formattingArgs, MarkdownSigns.NumberedList, [MarkdownSigns.BulletedList, MarkdownSigns.TaskList]),
    iconProps: { iconName: "NumberedList" },
    id: "numbered-list",
    order: 70,
    tooltipProps: { text: Resources.NumberedListText }
};
export const TaskList: IMarkdownToolbarCommand = {
    formatText: formattingArgs =>
        insertSignAtLineStart(formattingArgs, MarkdownSigns.TaskList, [MarkdownSigns.BulletedList, MarkdownSigns.NumberedList]),
    iconProps: { iconName: "CheckList" },
    id: "task-list",
    order: 80,
    tooltipProps: { text: Resources.TaskListText }
};

export const toolbarCommands: IMarkdownToolbarCommand[] = [Header, Bold, Italic, Code, Link, BulletedList, NumberedList, TaskList];
